function i(e, t) {
  if (e === t)
    return !0;
  if (!n(e) || !n(t))
    return e === t;
  if (Object.keys(e).length !== Object.keys(t).length) return !1;
  for (const r in e)
    if (!(r in t) || !i(e[r], t[r])) return !1;
  return !0;
}
function n(e) {
  return e === Object(e);
}
export {
  i
};
//# sourceMappingURL=deepEqual.js.map
